import { render } from "./GameMain.vue?vue&type=template&id=b571f208&bindings={\"code\":\"setup\",\"subtasksDone\":\"setup\",\"mainContent\":\"setup\"}"
import script from "./GameMain.vue?vue&type=script&lang=js"
export * from "./GameMain.vue?vue&type=script&lang=js"

import "./GameMain.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script